import { render, staticRenderFns } from "./IncomeMain.vue?vue&type=template&id=072fc63c"
import script from "./IncomeMain.vue?vue&type=script&lang=js"
export * from "./IncomeMain.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports